const TABS_PADDING_TOP = 4;
const TABS_HEIGHT = TABS_PADDING_TOP + 40;
const TABS_MARGIN_BOTTOM = 12;

const DETAIL_LAYOUT_MARGIN_BOTTOM = 32;

export const DETAIL_VIEW_SCROLL_OFFSET_TOP = TABS_HEIGHT + TABS_MARGIN_BOTTOM;

export const DETAIL_VIEW_ROOT_HEIGHT_OFFSET =
  TABS_HEIGHT + TABS_MARGIN_BOTTOM + DETAIL_LAYOUT_MARGIN_BOTTOM;
